/**
 * Meta legali — date di ultima revisione contenutistica (feb-2026 fix E5).
 *
 * Aggiornare quando il testo Privacy/Cookie/altri legali viene modificato in modo
 * sostanziale (non per meri fix di refactoring/formatting).
 */
export const PRIVACY_LAST_UPDATE = "15/02/2026";
export const COOKIE_LAST_UPDATE  = "15/02/2026";

/**
 * v1.68 (Fase 5) — versione consenso GDPR globale.
 * Deve essere allineata a `CONSENT_TEXT_VERSION` in `core/consensi_granulari.py`.
 * Bump quando il testo dei consensi viene modificato in modo sostanziale.
 */
export const PRIVACY_CONSENT_VERSION = "2026-02";
